import { apiFetch } from './client';
import type { Reminder } from '../types/contracts';

export const remindersApi = {
  list:   ()                                  => apiFetch<Reminder[]>('/api/reminders'),
  create: (d: { text: string; when: string; repeatEveryMin?: number }) =>
    apiFetch<Reminder>('/api/reminders', { method: 'POST', body: JSON.stringify(d) }),
  update: (id: string, d: { text?: string; when?: string; repeatEveryMin?: number }) =>
    apiFetch<Reminder>(`/api/reminders/${id}`, { method: 'PUT', body: JSON.stringify(d) }),
  remove: (id: string)                        =>
    apiFetch<{ deleted: boolean; id: string }>(`/api/reminders/${id}`, { method: 'DELETE' }),
  done:   (id: string)                        =>
    apiFetch<Reminder>(`/api/reminders/${id}/done`, { method: 'POST' }),
};
